import React from 'react';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';
import ACHFormIIAccept from './ACHFormIIAccept';
import ACHFormIIPlaid from './ACHFormIIPlaid';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  }
});

class ACHFormII extends React.Component {

  state = {
    accountId:    this.props.dAccountId,
    firstName:    this.props.dFirstName,
    lastName:     this.props.dLastName,
    email:        this.props.dEmail,
    phone:        this.props.dPhone,
    address1:     this.props.dAddress1,
    address2:     this.props.dAddress2,
    city:         this.props.dCity,
    state:        this.props.dState,
    country:      this.props.dCountry,
    dwollaCid:    this.props.pcId,
    achCDate:     abEnvironment.getUserAttribute('a_achCDate'),
    accepted:     false
  }

  setDwollaCid = (dwollaCid, nowdate) => {
//console.log('setting state');
    this.setState({dwollaCid: dwollaCid, achCDate: nowdate})
    this.props.setDwollaCidOnUInfo(dwollaCid);
  }

  handleCancel() {
    var paymentReturn = localStorage.getItem('paymentReturn');
    if (paymentReturn) {


      localStorage.removeItem('paymentReturn');
      //this.props.history.push (paymentReturn);
      window.location.reload();
    } else {

      window.location.reload();
    }

  }



  render() {
    const classes = this.props.classes;

    if (this.state.achCDate == null) {
      return (
        <div style={{height: 800}}>
          <ACHFormIIAccept pcId={this.state.dwollaCid} 
              dAccountId={this.props.dAccountId}
              dAccountName={this.props.dAccountName}
              dFirstName={this.props.dFirstName}
              dLastName={this.props.dLastName}
              dEmail={this.props.dEmail}
              dPhone={this.props.dPhone}
              dAddress1={this.props.dAddress1}
              dAddress2={this.props.dAddress2}
              dCity={this.props.dCity}
              dState={this.props.dState}
              dCountry={this.props.dCountry}
              auth={this.props.auth}
              setDwollaCid={this.setDwollaCid}
              history={this.props.history}
              onClose={this.props.onClose}
            />
        </div>
      );
    } else {
      return (
        <div style={{height: 800}}>
         <ACHFormIIPlaid pcId={this.state.dwollaCid} 
                        dAccountId={this.props.dAccountId}
                        dAccountName={this.props.dAccountName}
                        dFirstName={this.props.dFirstName}
                        dLastName={this.props.dLastName}
                        dEmail={this.props.dEmail}
                        dPhone={this.props.dPhone}
                        dAddress1={this.props.dAddress1}
                        dAddress2={this.props.dAddress2}
                        dCity={this.props.dCity}
                        dState={this.props.dState}
                        dCountry={this.props.dCountry}
                        auth={this.props.auth}
                        porder={this.props.porder}
                        history={this.props.history}
                        onClose={this.props.onClose}
          />
      </div>
      );
    }
  }
}

export default withStyles(styleSheet)(ACHFormII);